<script setup lang="ts">
import _ from 'lodash';
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { loadVideoByKey } from '@/modules/videoDetail/services';

const router = useRouter();
const route = useRoute();

const teamName = computed(() => route.params.teamName);
const videoKey = computed(() => route.params.videoKey);

onMounted(async () => {
  if (typeof videoKey.value !== 'string' || typeof teamName.value !== 'string') {
    await router.push('/');
    return;
  }

  try {
    const response = await loadVideoByKey(videoKey.value, { includes: ['project'] });
    const projectKey = _.get(response, 'data.project.key', '');

    if (projectKey) {
      // window.location.href = `${teamName.value}/projects/${projectKey}/videos/${videoKey.value}`;
      // Failed
      await router.push(`/${teamName.value}/projects/${projectKey}/videos/${videoKey.value}/information`);
    }
  } catch (error) {
    console.error(error);
    router.push(`/${teamName.value}/projects`);
  }
});
</script>
